export const FETCH_CONTEST_EVENT_RESULTS = 'FETCH_CONTEST_EVENT_RESULTS';
export const RECEIVE_CONTEST_EVENT_RESULTS = 'RECEIVE_CONTEST_EVENT_RESULTS';
export const FETCH_ACTIVE_CONTEST_EVENT_AGENTS = 'FETCH_ACTIVE_CONTEST_EVENT_AGENTS';
export const RECEIVE_ACTIVE_CONTEST_EVENT_AGENTS = 'RECEIVE_ACTIVE_CONTEST_EVENT_AGENTS';
export const FETCH_CONTEST_EVENT_PRIZE_PAYOUTS = 'FETCH_CONTEST_EVENT_PRIZE_PAYOUTS';
export const RECEIVE_CONTEST_EVENT_PRIZE_PAYOUTS = 'RECEIVE_CONTEST_EVENT_PRIZE_PAYOUTS';
export const FETCH_PRIZE_IMAGE = 'FETCH_PRIZE_IMAGE';
export const RECEIVE_PRIZE_IMAGE = 'RECEIVE_PRIZE_IMAGE';
export const CONTESTS_SET_SIGNAL_R_CONNECTION = 'CONTESTS_SET_SIGNAL_R_CONNECTION';
export const SET_SIGNALR_CONNECTION_CONTEST = 'SET_SIGNALR_CONNECTION_CONTEST';
export const RECEIVE_SIGNALR_DATA = 'RECEIVE_SIGNALR_DATA';
export const SIGNALR_CONTEST_CONNECTED = 'SIGNALR_CONTEST_CONNECTED';
export const SIGNALR_CONTEST_DISCONNECTED = 'SIGNALR_CONTEST_DISCONNECTED';
export const FETCH_AUTH_TOKEN = 'FETCH_AUTH_TOKEN';
export const RECEIVE_AUTH_TOKEN = 'RECEIVE_AUTH_TOKEN';
export const RESET_CONTEST_DATA = 'RESET_CONTEST_DATA';



// WEBPACK FOOTER //
// ./src/features/contests/redux/constants.js